import { TableCell, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import CookAuditInterface from "../../interfaces/Cook/CookAuditInterface";
import { CookService } from "../../services/CookServices";
import CkMuiTable from "../Common/CkMuiTable/CkMuiTable";
import { OneMealService } from "../../services/OneMealService";
import { CouponService } from "../../services/CouponService";
import ChefForPartyService from "../../services/ChefForPartyService";
import { formatDateTimeWithSeconds } from "../../utils/DateTimeUtils";
import CommonListTable, { CommonListColumn } from "../Common/CommonListTable";

const cookService = new CookService();
const oneMealService = new OneMealService();
const couponService = new CouponService();
const chefForPartyService = new ChefForPartyService();

interface InputProps {
  referenceId: number;
  referenceModel: string
}

const COLUMNS: CommonListColumn<CookAuditInterface>[] = [
  { label: 'Id', field: 'id' },
  { label: 'Reference Model', field: 'referenceModelName' },
  { label: 'Action Type', field: 'actionType' },
  { label: 'Changed By', field: 'changedBy' },
  { label: 'Changed By Type', field: 'changedByType' },
  {
    label: 'Previous Value',
    render: (audit) => (
      <CkMuiTable
        sx={{}}
        headers={["State", "Value"]}
        rowData={[]}
        isTablePagination={false}
      >
        {audit?.changes?.map((change: string) => (
          <TableRow key={change}>
            <TableCell>{change}</TableCell>
            <TableCell>{`${audit?.previousValue[change]}`}</TableCell>
          </TableRow>
        ))}
      </CkMuiTable>
    ),
  },
  {
    label: 'Next Value',
    render: (audit) => (
      <CkMuiTable
        sx={{}}
        headers={["State", "Value"]}
        rowData={[]}
        isTablePagination={false}
      >
        {audit?.changes?.map((change: string) => (
          <TableRow key={change}>
            <TableCell>{change}</TableCell>
            <TableCell>{`${audit?.nextValue[change]}`}</TableCell>
          </TableRow>
        ))}
      </CkMuiTable>
    ),
  },
  {
    label: 'Changes',
    render: (audit) => audit?.changes?.map((change: string, index: number) =>
      `${change}${audit.changes.length - 1 === index ? "" : ","}`
    ).join(' '),
  },
  {
    label: 'Created At',
    nowrap: true,
    render: (audit) => formatDateTimeWithSeconds(audit.createdAt),
  },
];

const CookAuditLogs = (props: InputProps) => {
  const [cookAuditLogs, setCookAuditLogs] = useState<CookAuditInterface[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (props.referenceModel === 'Cooks') {
      cookService.getAuditLogs(props.referenceId)
        .then((response) => { setCookAuditLogs(response); setLoading(false); })
        .catch((error) => { console.log(error); setLoading(false); });
    }
    if (props.referenceModel === 'Oms') {
      oneMealService.auditLogs(props.referenceId)
        .then((response) => { setCookAuditLogs(response); setLoading(false); })
        .catch((error) => { console.log(error); setLoading(false); });
    }
    if (props.referenceModel === 'Combo') {
      couponService.salesAuditLogs(props.referenceId)
        .then((response) => { setCookAuditLogs(response); setLoading(false); })
        .catch((error) => { console.log(error); setLoading(false); });
    }
    if (props.referenceModel === 'ChefForParty') {
      chefForPartyService.auditLogs(props.referenceId)
        .then((response) => { setCookAuditLogs(response); setLoading(false); })
        .catch((error) => { console.log(error); setLoading(false); });
    }
  }, [props.referenceId, props.referenceModel]);

  return (
    <CommonListTable
      columns={COLUMNS}
      data={cookAuditLogs}
      loading={loading}
      emptyText="No Data Found"
    />
  );
};

export default CookAuditLogs;
